<template>
  <div class="unit-items">
    <div class="unit-title">
      <h3 class="font-weight-regular headline mb-0 white--text">{{ title }}</h3>
      <v-btn @click="add" class="ma-1 white" fab small light v-if="!isLocked">
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <v-card v-if="items.length === 0" class="mb-3 mt-5" @click="add">
      <v-card-title>
        <h2 class="body-1">Click to start adding items</h2>
      </v-card-title>
    </v-card>

    <template>
      <draggable
        class="mt-5"
        :list="items"
        group="order"
        @start="startDrag()"
        @end="endDrag()"
        :ref="name"
        :id="name"
      >
        <v-card
          light
          v-for="(item, index) in items"
          :key="`unit-${name}-${index}`"
          class="mb-3"
          :data-id="item.id"
        >
          <v-card-title>
            <h4>{{ item.title }}</h4>
          </v-card-title>
          <v-card-text v-show="item.showDetails">
            <div>
              <p class="pb-0 mb-0 black--text">What makes then unique to SF?</p>
              <p class="pb-0 mb-2">{{ item.what }}</p>
              <p class="pb-0 mb-0 black--text">What can we learn from them?</p>
              <p class="pb-0 mb-2">{{ item.learn }}</p>
              <p class="pb-0 mb-0 black--text">What do you do differently?</p>
              <p class="pb-0 mb-2">{{ item.difference }}</p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              dark
              class="grey darken-1"
              x-small
              @click="toggleShow(item)"
              >{{ showLabel(item) }}</v-btn
            >
            <v-btn dark class="grey darken-1" x-small @click="edit(item)"
              >Edit</v-btn
            >
            <v-btn dark class="grey darken-1" x-small @click="remove(item)"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </draggable>
    </template>

    <v-btn
      v-if="items.length >= 1"
      class="grey lighten-3 mr-2 mt-6"
      light
      small
      @click="expandAll()"
      >Expand</v-btn
    >
    <v-btn
      v-if="items.length >= 1"
      class="grey lighten-3 mt-6"
      light
      small
      @click="collapseAll()"
      >Collapse</v-btn
    >

    <div class="block black--text mt-10 opacity-0">{{ listCount }}</div>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <v-textarea
            label="Name of institution"
            color="green"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What makes then unique to SF?"
            color="green"
            v-model="item.what"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What can we learn from them?"
            color="green"
            v-model="item.learn"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What do you do differently?"
            color="green"
            v-model="item.difference"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-btn light color="green" class="mt-2 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-2 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </v-card-text>
      </v-card>
      <v-card light v-else>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <v-textarea
            label="Name of institution?"
            color="green"
            v-model="item.title"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What makes then unique to SF?"
            color="green"
            v-model="item.what"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What can we learn from them?"
            color="green"
            v-model="item.learn"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-textarea
            label="What do you do differently?"
            color="green"
            v-model="item.difference"
            :rows="3"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-btn light color="green" class="mt-2 mr-2" @click="addItem"
            >Add</v-btn
          >
          <v-btn light color="white" class="mt-2 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";

export default {
  name: "FourCornersCulture",
  data() {
    return {
      items: this.value,
      item: {},
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
      currItem: null,
      currIndex: null,
      expanded: false,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    isLocked: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    listCount: {
      type: Number,
      default: 0,
    },
  },
  components: {
    draggable,
  },
  computed: {
    expandLabel() {
      return this.expanded ? "Collapse" : "Expand";
    },
  },
  watch: {
    value: {
      handler(val) {
        this.items = val;
      },
      deep: true,
      immediate: true,
    },
    listCount: {
      immediate: true,
      handler() {
        this.items = this.value;
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.items = this.value;
    });
  },
  methods: {
    rand() {
      return Math.random()
        .toString(36)
        .substr(2);
    },
    generateToken() {
      console.log("token");
      return this.rand() + this.rand() + this.rand();
    },
    checkToken(id) {
      console.log("check token");
      return id.toString().length < 3 ? this.generateToken() : id;
    },
    add() {
      this.dialog = true;
    },
    expandAll() {
      this.items.forEach((x) => {
        x.showDetails = true;
      });
    },
    collapseAll() {
      this.items.forEach((x) => {
        x.showDetails = false;
      });
    },
    addItem() {
      let item = {
        index: this.items.length,
        id: this.generateToken(),
        type: "content",
        showDetails: true,
        ...this.item,
      };
      this.items.push(item);
      this.item = {};
      this.editMode = false;
      this.dialog = false;
      this.$emit("autosave");
    },
    toggleShow(target) {
      const item = this.items.find((x) => x.id === target.id);
      item.showDetails = !item.showDetails;
      const index = this.items.indexOf(item);
      this.$set(this.items, index, item);
    },
    showLabel(item) {
      return item.showDetails ? "Collapse" : "Expand";
    },
    remove(target) {
      this.deleteMode = true;
      const item = this.items.find((x) => x.title === target.title);
      const index = this.items.indexOf(item);
      this.item = item;
      this.currIndex = index;
      this.dialog = true;
      this.$emit("autosave");
    },
    removeItem() {
      this.items.splice(this.currIndex, 1);
      this.cancel();
    },
    edit(target) {
      const item = this.items.find((x) => x.title === target.title);
      const index = this.items.indexOf(item);
      this.item = item;
      this.currIndex = index;
      this.editMode = !this.editMode;
      this.dialog = true;
    },
    editItem() {
      let item = {
        ...this.item,
        index: this.currIndex,
        id: this.checkToken(this.item.id),
        type: "content",
      };
      this.$set(this.items, this.currIndex, item);
      this.item = {};
      this.currItem = null;
      this.currIndex = null;
      this.editMode = false;
      this.dialog = false;
      this.$emit("autosave");
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
      this.$emit("autosave");
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    &--white {
      background: white;
      display: block;
      width: 100%;
      color: black;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: #2b2a2a;
    border-radius: 5px;
    color: white;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
</style>
